import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useAlertPhase } from '../../hooks/useAlertPhase'
import { useRealtimeBridge } from '../../hooks/useRealtimeBridge'
import { SideNav } from './SideNav'
import { TopBar } from './TopBar'

/** 应用壳：全局挂 MQTT 桥 + 警报相位同步 + 顶栏紧急滚动条 + 侧栏导航 */
export function AppShell() {
  useRealtimeBridge()
  const phase = useAlertPhase()

  // 相位写入根元素：任何组件/CSS 均可按 html[data-phase] 联动
  useEffect(() => {
    document.documentElement.dataset.phase = phase
    return () => {
      delete document.documentElement.dataset.phase
    }
  }, [phase])

  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <SideNav />
      <main className="lg:pl-56">
        <div className="mx-auto max-w-[1760px] px-4 pb-10 pt-[6.75rem] lg:px-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
